function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 359.323,
    cy: 137.829,
    r: 52.424
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 355.344,
    cy: 137.829,
    r: 52.424
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 6.6181 291.6353)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 355.344,
    cy: 137.829,
    rx: 48.446,
    ry: 48.446
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M363.596,173.093c-0.529,0-1.011-0.361-1.141-0.899l-8.253-34.089 c-0.152-0.63,0.235-1.265,0.865-1.418c0.628-0.155,1.265,0.234,1.418,0.865l8.253,34.089c0.152,0.63-0.235,1.265-0.865,1.418 C363.781,173.083,363.688,173.093,363.596,173.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M355.344,140.178c-0.602,0-1.202-0.229-1.661-0.688l-28.35-28.35 c-0.917-0.917-0.917-2.404,0-3.321c0.918-0.918,2.404-0.918,3.322,0l26.689,26.688l15.564-15.563 c0.918-0.918,2.404-0.918,3.322,0c0.917,0.917,0.917,2.404,0,3.321l-17.225,17.225 C356.546,139.949,355.946,140.178,355.344,140.178z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 221.502,
    y: 321,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 450.9002 696.0974)",
    style: {
      fill: "#F0F0F0"
    },
    width: 7.897,
    height: 54.098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.701,
    y: 375.098,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 285.8853 757.496)",
    style: {
      fill: "#F0F0F0"
    },
    width: 162.484,
    height: 7.301
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.487,
    y: 321,
    style: {
      fill: "#F5F5F5"
    },
    width: 165.015,
    height: 54.098
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.163,
    y: 330.415,
    style: {
      fill: "#F0F0F0"
    },
    width: 143.663,
    height: 30.897
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M104.042,334.557h69.904c1.303,0,2.368-1.066,2.368-2.368v-0.446 c0-1.302-1.066-2.368-2.368-2.368h-69.904c-1.302,0-2.368,1.066-2.368,2.368v0.446 C101.674,333.492,102.74,334.557,104.042,334.557z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.868,
    y: 316.167,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 274.3702 637.1665)",
    style: {
      fill: "#F0F0F0"
    },
    width: 168.633,
    height: 4.833
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.502,
    y: 316.167,
    style: {
      fill: "#E6E6E6"
    },
    width: 11.692,
    height: 4.833
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.286,
    y: 263.88,
    style: {
      fill: "#F0F0F0"
    },
    width: 15.398,
    height: 118.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 263.88,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 693.7861 646.2783)",
    style: {
      fill: "#F5F5F5"
    },
    width: 134.786,
    height: 118.519
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.271,
    y: 308.605,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 674.8816 680.5999)",
    style: {
      fill: "#FAFAFA"
    },
    width: 118.341,
    height: 63.389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.271,
    y: 281.01,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 674.8816 582.8895)",
    style: {
      fill: "#FAFAFA"
    },
    width: 118.341,
    height: 20.869
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.611,
    y: 308.604,
    style: {
      opacity: 0.7,
      fill: "#E6E6E6"
    },
    width: 1.056,
    height: 63.389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.611,
    y: 281.009,
    style: {
      opacity: 0.7,
      fill: "#E6E6E6"
    },
    width: 1.056,
    height: 20.869
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.159,
    y: 268.881,
    style: {
      opacity: 0.7,
      fill: "#E6E6E6"
    },
    width: 150.525,
    height: 2.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 414.286,
    y: 262.258,
    style: {
      fill: "#F0F0F0"
    },
    width: 17.197,
    height: 7.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.701,
    y: 262.258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 691.9872 532.267)",
    style: {
      fill: "#F5F5F5"
    },
    width: 136.585,
    height: 7.751
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M328.941,239.44c-0.999-1.405-1.466-3.126-1.797-4.819c-0.255-1.708-0.384-3.458-0.264-5.182 c0.214-3.452,0.965-6.863,2.178-10.055c0.535-1.631,1.315-3.148,2.003-4.705c0.795-1.501,1.603-2.994,2.496-4.431 c0.937-1.41,1.896-2.803,2.917-4.144c1.088-1.299,2.164-2.597,3.358-3.8c-0.577,1.611-1.274,3.127-1.958,4.642 c-0.686,1.512-1.299,3.052-2.008,4.531l-1.932,4.507l-0.888,2.268l-0.464,1.124l-0.397,1.144 c-1.154,3.023-2.049,6.106-2.716,9.241c-0.338,1.569-0.574,3.156-0.7,4.769C328.644,236.144,328.634,237.776,328.941,239.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M309.529,242.089c0.088-2.561-0.069-4.971-0.628-7.191c-0.55-2.218-1.533-4.182-2.932-5.84 c-1.418-1.647-3.234-3.002-5.283-4.161c-2.041-1.184-4.302-2.121-6.639-3.214c2.563-0.273,5.172-0.013,7.685,0.816 c1.257,0.411,2.483,0.979,3.64,1.703c1.145,0.743,2.215,1.642,3.133,2.703c1.824,2.141,2.871,4.926,2.979,7.636 C311.594,237.251,310.94,239.916,309.529,242.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M310.397,241.74c-0.103-2.914-0.339-5.696-0.792-8.399c-0.457-2.694-1.128-5.3-2.188-7.711 c-1.037-2.422-2.449-4.641-4.234-6.638c-1.788-1.999-3.952-3.723-6.325-5.441c2.892,0.431,5.706,1.653,8.104,3.523 c2.388,1.881,4.314,4.419,5.508,7.238c1.229,2.811,1.746,5.859,1.734,8.831C312.164,236.115,311.65,239.076,310.397,241.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M327.609,236.631c-2.228-2.796-3.965-5.914-5.499-9.112c-1.509-3.213-2.743-6.558-3.711-9.983 c-0.993-3.418-1.603-6.954-1.93-10.505c-0.307-3.553-0.175-7.163,0.491-10.659c0.73,3.504,1.286,6.899,2.095,10.264 c0.791,3.358,1.591,6.695,2.547,10.005c0.932,3.313,1.913,6.619,2.938,9.934C325.553,229.897,326.618,233.208,327.609,236.631z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M326.712,236.38c-2.536-2.389-4.647-5.146-6.583-8.004c-1.913-2.876-3.59-5.912-5.03-9.062 c-1.456-3.143-2.581-6.447-3.439-9.811c-0.824-3.374-1.272-6.862-1.152-10.331c1.258,3.252,2.352,6.419,3.642,9.531 c1.287,3.105,2.571,6.19,3.977,9.237c1.391,3.051,2.815,6.094,4.268,9.147C323.838,230.15,325.315,233.201,326.712,236.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M330.428,239.577c-2.846-1.438-5.373-3.368-7.744-5.452c-2.354-2.108-4.506-4.445-6.439-6.96 c-1.954-2.498-3.589-5.256-4.96-8.123c-1.351-2.88-2.303-5.967-2.701-9.112c1.718,2.69,3.237,5.319,4.981,7.829 c1.73,2.507,3.455,4.99,5.325,7.388c1.848,2.41,3.74,4.795,5.678,7.175C326.498,234.712,328.473,237.076,330.428,239.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M324.989,236.396c-2.756-1.067-5.224-2.726-7.482-4.596c-2.258-1.882-4.283-4.049-6.037-6.419 c-0.906-1.165-1.666-2.437-2.44-3.69c-0.681-1.313-1.415-2.592-1.931-3.982c-1.165-2.705-1.845-5.619-2.086-8.537 c1.567,2.51,2.858,4.997,4.413,7.341c0.707,1.204,1.539,2.33,2.278,3.503c0.827,1.12,1.572,2.289,2.434,3.381 c1.648,2.233,3.38,4.414,5.202,6.551C321.155,232.1,323.033,234.206,324.989,236.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M329.258,238.112c-1.313-0.84-2.251-2.19-2.981-3.584c-0.667-1.426-1.208-2.953-1.445-4.516 c-0.517-3.123-0.387-6.328,0.259-9.358c0.286-1.529,0.759-3,1.203-4.474c0.564-1.428,1.076-2.878,1.758-4.245 c0.7-1.358,1.404-2.711,2.211-3.999c0.862-1.263,1.709-2.523,2.686-3.7c-0.318,1.515-0.765,2.946-1.199,4.375 c-0.454,1.418-0.793,2.869-1.256,4.261c-0.423,1.407-0.755,2.829-1.179,4.219l-0.492,2.111 c-0.167,0.701-0.375,1.396-0.47,2.104c-0.604,2.809-0.921,5.63-0.926,8.452c-0.013,1.416,0.122,2.822,0.383,4.229 C328.071,235.396,328.502,236.784,329.258,238.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M327.403,234.92c-2.238-2.258-3.715-5.206-4.636-8.285c-0.893-3.094-1.237-6.398-0.872-9.634 c0.055-0.812,0.256-1.604,0.382-2.405l0.235-1.194l0.352-1.162c0.254-0.768,0.477-1.545,0.766-2.296 c0.331-0.735,0.675-1.462,1.024-2.183l0.532-1.074l0.649-1.009l1.327-1.978c0.983-1.245,2.066-2.409,3.19-3.496 c-0.521,1.516-1.212,2.881-1.768,4.301l-0.79,2.131l-0.408,1.046l-0.314,1.077c-0.213,0.714-0.43,1.421-0.662,2.12l-0.491,2.15 l-0.257,1.067l-0.152,1.085c-0.094,0.722-0.272,1.435-0.307,2.162c-0.331,2.895-0.243,5.816,0.113,8.746 C325.673,229.03,326.363,231.954,327.403,234.92z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "323.18,233.702 308.849,220.949 310.972,238.258  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "295.565,231.374 337.137,231.374 331.694,262.258 301.009,262.258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "321.536,231.374 337.137,231.374 331.694,262.258 323.5,262.258  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M373.864,239.503c0.199-1.43,0.125-2.789-0.171-4.099c-0.287-1.302-0.674-2.551-1.237-3.738 c-1.094-2.374-2.528-4.587-4.23-6.654c-0.374-0.55-0.864-1.025-1.3-1.535c-0.444-0.507-0.866-1.032-1.329-1.528 c-0.968-0.956-1.856-1.996-2.843-2.96c-1.001-0.947-1.94-1.98-2.946-2.958c-1.001-0.986-2.016-1.968-2.96-3.086 c1.353,0.502,2.636,1.14,3.933,1.774c1.279,0.659,2.457,1.485,3.665,2.276c0.612,0.386,1.159,0.861,1.72,1.32 c0.564,0.456,1.11,0.934,1.664,1.405c1.036,1.025,2.077,2.058,2.993,3.215c1.866,2.272,3.342,4.974,4.105,7.902 c0.387,1.458,0.515,3.003,0.389,4.502C375.173,236.827,374.756,238.336,373.864,239.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M397.237,235.313c-1.049-0.856-1.785-2.084-2.252-3.422c-0.264-0.671-0.338-1.387-0.444-2.114 c-0.029-0.362,0-0.726,0.006-1.094c0.015-0.367,0.003-0.745,0.104-1.096c0.502-2.928,2.225-5.457,4.238-7.361 c0.505-0.483,1.066-0.878,1.599-1.317c0.551-0.412,1.078-0.865,1.677-1.181c0.587-0.34,1.167-0.687,1.761-1.009 c0.297-0.16,0.586-0.335,0.888-0.48l0.927-0.388c0.618-0.256,1.239-0.501,1.862-0.736c0.619-0.244,1.247-0.46,1.898-0.608 c1.299-0.31,2.585-0.626,3.909-0.794c-1.054,0.856-2.147,1.564-3.227,2.278c-0.553,0.33-1.079,0.703-1.598,1.078 c-0.523,0.368-1.049,0.724-1.577,1.07c-1.089,0.652-2.018,1.484-3.042,2.18c-0.523,0.339-0.962,0.757-1.422,1.153 c-0.454,0.397-0.954,0.757-1.376,1.176c-1.729,1.645-3.18,3.456-3.989,5.566c-0.229,0.523-0.304,1.08-0.465,1.641 c-0.049,0.566-0.174,1.154-0.134,1.75C396.569,232.806,396.801,234.048,397.237,235.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M396.167,235.313c-1.822-2.247-2.719-5.218-2.792-8.207c-0.08-3.008,0.767-6.044,2.234-8.667 l1.202-1.904c0.461-0.584,0.952-1.143,1.437-1.703l0.737-0.83l0.829-0.725c0.553-0.482,1.115-0.95,1.677-1.411 c1.189-0.835,2.435-1.579,3.684-2.271c1.328-0.569,2.639-1.138,4.001-1.56c-0.994,1.064-2.039,1.982-3.066,2.9 c-0.958,1.001-1.943,1.936-2.884,2.89c-0.435,0.512-0.871,1.015-1.316,1.505l-0.667,0.733l-0.576,0.796 c-0.38,0.53-0.797,1.032-1.166,1.563l-0.995,1.651c-1.241,2.233-2.138,4.623-2.529,7.184 C395.572,229.817,395.615,232.512,396.167,235.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M375.141,236.79c0.825-3.093,1.733-6.07,2.599-9.048c0.876-2.971,1.719-5.925,2.503-8.885 c0.749-2.968,1.424-5.935,2.001-8.943c0.523-3.017,0.874-6.042,1.15-9.246c1.109,3.012,1.472,6.276,1.453,9.501 c-0.107,3.221-0.594,6.42-1.385,9.525c-0.824,3.095-1.926,6.104-3.288,8.983C378.784,231.54,377.202,234.323,375.141,236.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M376.179,236.294c1.299-3.05,2.699-5.964,4.077-8.878c1.385-2.907,2.772-5.79,4.108-8.686 c1.312-2.905,2.602-5.807,3.793-8.764c1.168-2.968,2.208-5.964,3.213-9.134c0.386,3.302-0.008,6.663-0.716,9.911 c-0.768,3.237-1.904,6.368-3.27,9.377c-1.387,3-3.026,5.87-4.87,8.596C380.646,231.423,378.618,234.033,376.179,236.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M372.112,240.1c1.947-2.683,3.963-5.21,5.957-7.744c1.999-2.524,3.995-5.024,5.944-7.549 c1.928-2.539,3.833-5.08,5.655-7.696c1.801-2.632,3.484-5.32,5.172-8.185c-0.361,3.305-1.495,6.493-2.911,9.501 c-1.471,2.984-3.277,5.782-5.281,8.41c-2.022,2.614-4.26,5.046-6.667,7.291C377.553,236.349,374.994,238.44,372.112,240.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M378.23,235.744c1.906-2.396,3.824-4.656,5.696-6.943c1.878-2.275,3.706-4.557,5.482-6.868 c1.779-2.311,3.429-4.693,5.05-7.122c1.617-2.442,3.012-4.993,4.543-7.665c-0.187,3.055-1.01,6.079-2.238,8.902 c-1.266,2.802-2.837,5.478-4.71,7.902c-1.87,2.428-3.966,4.669-6.262,6.673C383.477,232.603,381.009,234.425,378.23,235.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M373.342,238.529c1.181-2.348,1.586-4.744,1.518-7.033c-0.09-2.3-0.756-4.521-1.743-6.652 l-0.336-0.812l-0.434-0.78l-0.837-1.586c-0.667-1.008-1.274-2.066-1.961-3.093c-0.734-0.993-1.393-2.064-2.131-3.094 c-0.743-1.029-1.501-2.059-2.173-3.216c1.166,0.606,2.246,1.339,3.341,2.073c1.065,0.766,2.007,1.686,2.985,2.577 c0.499,0.436,0.891,0.981,1.329,1.481c0.431,0.509,0.851,1.028,1.26,1.559l1.071,1.724l0.511,0.879l0.417,0.943 c1.145,2.473,1.742,5.36,1.303,8.164C377.012,234.431,375.593,237.086,373.342,238.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M375.198,235.335c0.839-2.604,1.426-5.134,1.68-7.63c0.254-2.491,0.103-4.926-0.529-7.22 c-0.304-1.151-0.737-2.269-1.294-3.341c-0.538-1.082-1.191-2.126-1.94-3.132c-1.479-2.03-3.297-3.905-5.224-5.865 c2.64,0.773,5.09,2.185,7.173,4.12c1.05,0.958,1.97,2.085,2.737,3.323c0.781,1.23,1.369,2.598,1.756,4.018 c0.785,2.846,0.683,5.883-0.123,8.607C378.615,230.934,377.217,233.445,375.198,235.335z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "380.086,232.969 395.73,217.949 395.102,232.678  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "362.983,231.374 404.556,231.374 399.112,262.258 368.427,262.258  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "388.955,231.374 404.556,231.374 399.112,262.258 390.918,262.258  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M103.873,90.721v161.946c0,14.031-11.375,25.406-25.406,25.406h118.035 c14.031,0,25.406-11.375,25.406-25.406V90.721H103.873z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.115,
    y: 131.725,
    style: {
      fill: "#F0F0F0"
    },
    width: 76.245,
    height: 76.245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.768,
    y: 129.378,
    style: {
      fill: "#FFFFFF"
    },
    width: 76.245,
    height: 76.245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.104,
    y: 216.916,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.393,
    height: 19.393
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.62,
    y: 216.916,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.393,
    height: 19.393
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.862,
    y: 216.916,
    style: {
      fill: "#FFFFFF"
    },
    width: 19.393,
    height: 19.393
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "103.873,90.721 103.873,110 103.873,110 221.908,110 221.908,90.721  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M110.96,84.53v12.383c0,1.904,1.544,3.448,3.448,3.448h0c1.904,0,3.448-1.544,3.448-3.448 l0-12.383c0-1.904-1.544-3.448-3.448-3.448l0,0C112.503,81.082,110.96,82.625,110.96,84.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M207.925,84.53v12.383c0,1.904,1.544,3.448,3.448,3.448h0c1.904,0,3.448-1.544,3.448-3.448 l0-12.383c0-1.904-1.544-3.448-3.448-3.448h0C209.469,81.082,207.925,82.625,207.925,84.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M188.532,84.53v12.383c0,1.904,1.544,3.448,3.448,3.448h0c1.904,0,3.448-1.544,3.448-3.448 l0-12.383c0-1.904-1.544-3.448-3.448-3.448h0C190.076,81.082,188.532,82.625,188.532,84.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M169.139,84.53v12.383c0,1.904,1.544,3.448,3.448,3.448h0c1.904,0,3.448-1.544,3.448-3.448 l0-12.383c0-1.904-1.544-3.448-3.448-3.448l0,0C170.682,81.082,169.139,82.625,169.139,84.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M149.746,84.53v12.383c0,1.904,1.544,3.448,3.448,3.448h0c1.904,0,3.448-1.544,3.448-3.448 l0-12.383c0-1.904-1.544-3.448-3.448-3.448l0,0C151.289,81.082,149.746,82.625,149.746,84.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M130.353,84.53v12.383c0,1.904,1.544,3.448,3.448,3.448h0c1.904,0,3.448-1.544,3.448-3.448 l0-12.383c0-1.904-1.544-3.448-3.448-3.448l0,0C131.896,81.082,130.353,82.625,130.353,84.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M185.873,267.444c0,5.87,4.759,10.629,10.629,10.629h-10.629H63.689 c-5.87,0-10.629-4.759-10.629-10.629H185.873z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M250.664,126.625c73.679-16.85,132.279,43.467,138.447,92.273 c8.431,66.71-90.427,120.856-164.799,136.145c-78.376,16.112-127.855-25.466-124.539-86.717 C102.473,218.446,187.511,141.067,250.664,126.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M250.664,126.625c73.679-16.85,132.279,43.467,138.447,92.273 c8.431,66.71-90.427,120.856-164.799,136.145c-78.376,16.112-127.855-25.466-124.539-86.717 C102.473,218.446,187.511,141.067,250.664,126.625z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__357_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hourglass"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M269.592,320.73c0,0-73.494,43.388-73.494,84.499h146.988 C343.086,364.118,269.592,320.73,269.592,320.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M269.592,372.5c0,0-67.858,16.805-67.858,32.729H337.45 C337.45,389.305,269.592,372.5,269.592,372.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M278.514,332.714c13.793,13.564,40.618,43.637,40.618,72.515h-18.387 C300.745,376.35,286.059,346.277,278.514,332.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M269.592,320.73c0,0-73.494-43.388-73.494-84.499h146.988 C343.086,277.342,269.592,320.73,269.592,320.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M269.592,316.766c0,0-37.524-18.022-37.524-35.099h75.048 C307.116,298.743,269.592,316.766,269.592,316.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M261.58,308.746c-13.794-13.564-40.618-43.637-40.618-72.515h18.387 C239.349,265.109,254.035,295.182,261.58,308.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M278.514,308.746c13.793-13.564,39.946-47.115,40.618-72.515h-4.905 C311.929,267.196,289.43,295.622,278.514,308.746z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 324.783,
    y: 221.722,
    style: {
      fill: "#407BFF"
    },
    width: 8.334,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M361.394,235.461h-1c0-7.024-5.715-12.739-12.738-12.739h-8.789v-1h8.789 C355.231,221.722,361.394,227.885,361.394,235.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M347.655,247.24H191.529c-5.631,0-10.239-4.607-10.239-10.239v-1.541 c0-5.631,4.607-10.239,10.239-10.239h156.127c5.631,0,10.239,4.607,10.239,10.239v1.541 C357.894,242.633,353.287,247.24,347.655,247.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M347.655,394.22H191.529c-5.631,0-10.239,4.607-10.239,10.239v1.541 c0,5.631,4.607,10.239,10.239,10.239h156.127c5.631,0,10.239-4.607,10.239-10.239v-1.541 C357.894,398.827,353.287,394.22,347.655,394.22z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "140.721,304.52 133.942,298.502 145.497,280.746 152.275,286.764  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M135.34,294.683l8.623,5.982c0.314,0.218,0.399,0.6,0.206,0.919l-4.315,7.113 c-0.448,0.738-1.576,0.947-2.29,0.433c-2.966-2.134-4.109-3.169-7.703-6.065c-2.211-1.782-7.477-6.068-10.197-8.892 c-2.661-2.762,0.15-5.435,1.555-4.48c3.326,2.261,9.124,4.744,12.472,4.545C134.295,294.202,134.881,294.365,135.34,294.683z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "152.274,286.77 145.492,280.75 139.932,289.302 146.88,295.066  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M221.247,198.1c0,0-45.497-3.105-51.14,12.314c-12.827,35.052-29.522,72.248-29.522,72.248 l13.45,9.705c0,0,28.357-43.342,36.973-71.175c17.5,4.246,49.139,7.883,59.334-3.816c8.696-9.979,2.187-19.275,2.187-19.275 H221.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M182.275,225.355c-1.058,4.272-2.665,16.538-3.664,24.67c2.204-4.281,4.311-8.622,6.202-12.864 L182.275,225.355z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "153.142,296.76 137.925,284.838 141.036,278.161 158.045,291.152  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M131.692,294.133c0.709,0.492,1.595,0.89,2.236,1.144c0.08,0.032,0.171,0.014,0.232-0.046 c0.062-0.061,0.081-0.151,0.052-0.231c-0.127-0.34-1.27-3.333-2.462-3.615c-0.276-0.066-0.542,0.009-0.768,0.218 c-0.373,0.343-0.524,0.722-0.449,1.126C130.628,293.242,131.097,293.721,131.692,294.133z M133.616,294.677 c-1.563-0.679-2.544-1.423-2.656-2.028c-0.046-0.251,0.057-0.488,0.316-0.727c0.12-0.11,0.238-0.146,0.372-0.114 C132.29,291.96,133.119,293.493,133.616,294.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M133.884,295.254c0.028,0.019,0.061,0.032,0.096,0.037c0.074,0.01,0.148-0.019,0.196-0.077 c0.072-0.088,1.776-2.176,1.519-3.46c-0.069-0.346-0.267-0.607-0.585-0.776c-0.383-0.203-0.747-0.17-1.024,0.091 c-0.758,0.714-0.725,3.11-0.276,4.096C133.827,295.202,133.852,295.232,133.884,295.254z M134.993,291.415 c0.149,0.103,0.239,0.242,0.275,0.424c0.154,0.766-0.66,2.074-1.187,2.788c-0.276-1.027-0.194-2.772,0.303-3.241 c0.094-0.09,0.24-0.173,0.522-0.024C134.938,291.379,134.967,291.397,134.993,291.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "200.501,315.013 191.749,316.765 190.13,293.329 199.022,293.611  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M190.559,313.561l9.975-4.214c0.363-0.153,0.743-0.017,0.915,0.328l3.817,7.688 c0.396,0.797-0.045,1.897-0.887,2.236c-3.498,1.407-5.243,1.904-9.63,3.757c-2.699,1.14-9.972,4.445-13.899,5.417 c-3.841,0.951-4.778-2.94-3.2-3.702c3.737-1.805,9.935-7.29,11.61-10.318C189.563,314.207,190.028,313.786,190.559,313.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M188.066,316.438c0.82-0.346,1.656-0.899,2.232-1.317c0.072-0.052,0.106-0.141,0.088-0.228 c-0.019-0.087-0.087-0.154-0.173-0.173c-0.367-0.077-3.606-0.734-4.511,0.15c-0.21,0.204-0.291,0.477-0.234,0.789 c0.093,0.515,0.34,0.856,0.733,1.013C186.701,316.873,187.378,316.728,188.066,316.438z M189.602,315.061 c-1.455,0.987-2.645,1.432-3.234,1.195c-0.244-0.098-0.394-0.319-0.459-0.677c-0.03-0.165,0.004-0.288,0.106-0.387 C186.502,314.716,188.295,314.84,189.602,315.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M190.253,315.146c0.032-0.014,0.062-0.035,0.085-0.063c0.049-0.059,0.065-0.14,0.041-0.214 c-0.037-0.112-0.916-2.75-2.177-3.235c-0.34-0.131-0.676-0.102-0.999,0.082c-0.388,0.222-0.561,0.557-0.486,0.943 c0.204,1.055,2.311,2.349,3.418,2.502C190.176,315.167,190.216,315.161,190.253,315.146z M187.519,312.059 c0.172-0.073,0.343-0.075,0.521-0.006c0.752,0.289,1.443,1.72,1.774,2.574c-1.047-0.326-2.523-1.362-2.657-2.054 c-0.026-0.132-0.018-0.305,0.267-0.468C187.457,312.088,187.488,312.072,187.519,312.059z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "199.025,293.617 190.128,293.335 190.979,305.573 199.844,305.411  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M243.355,198.1c0,0-65.028,6.148-62.66,25.722c3.415,28.231,5.917,77.657,5.917,77.657 l16.573,0.651c0,0,6.212-43.461,2.578-72.369c16.829,0,53.384,0.885,59.816-7.808c7.636-10.319,4.1-23.853,4.1-23.853H243.355 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "205.015,303.15 185.124,302.164 184.409,293.507 206.222,295.013  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M228.918,140.791c-0.143,1.789-0.296,3.382-0.515,5.053c-0.208,1.651-0.438,3.297-0.689,4.942 c-0.488,3.293-1.141,6.568-1.881,9.856c-0.781,3.28-1.651,6.572-2.795,9.874c-1.166,3.299-2.475,6.626-4.53,10.007 c-1.049,1.686-2.269,3.408-4.03,5.084c-0.472,0.45-0.876,0.765-1.285,1.087c-0.412,0.339-0.825,0.622-1.239,0.915 c-0.826,0.581-1.658,1.095-2.493,1.552c-3.333,1.841-6.64,3.094-9.952,4.074c-1.65,0.501-3.305,0.918-4.958,1.283 c-1.65,0.374-3.302,0.69-4.957,0.949c-3.324,0.534-6.57,0.886-10.007,1.001c-1.89,0.063-3.474-1.418-3.537-3.308 c-0.052-1.552,0.938-2.898,2.34-3.364l0.134-0.044c5.845-1.939,11.834-4.04,17.222-6.56c2.687-1.269,5.263-2.646,7.384-4.18 c0.528-0.384,1.024-0.773,1.475-1.158c0.222-0.195,0.456-0.385,0.642-0.581c0.203-0.196,0.412-0.397,0.507-0.514 c0.517-0.586,1.135-1.526,1.692-2.609c1.131-2.191,2.116-4.893,2.913-7.689c0.808-2.806,1.509-5.738,2.091-8.721 c0.619-2.977,1.101-6.014,1.591-9.057c0.473-3.017,0.858-6.183,1.202-9.085l0.019-0.163c0.447-3.764,3.86-6.452,7.623-6.006 C226.559,133.864,229.206,137.138,228.918,140.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M179.816,188.017l-5.011,0.317l4.003,9.201c0,0,8.652-0.197,8.473-4.457l-1.563-2.036 C184.379,189.296,182.199,188.179,179.816,188.017z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "169.34,189.072 173.663,197.534 178.808,197.534 174.805,188.333  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M228.199,126.611l9.674-1.981l7.693-1.114c1.102-0.16,2.22-0.247,3.329-0.146 c5.979,0.542,11.117,4.72,12.746,10.64c1.925,6.995,3.667,15.585,5.006,23.198c1.859,10.569,2.828,26.453,3.032,40.891H223.83 c-0.96-26.145-6.559-43.011-8.449-53.447c-1.175-6.486,2.141-12.954,8.091-15.789L228.199,126.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M223.83,132.36c0.109,4.3,0.98,19.635,5.606,28.344c0.816-8.165,10.505-33.025,10.505-33.025 L223.83,132.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M267.685,164.381c0.002,0.001,0.003,0.002,0.005,0.004c-0.02-0.163-0.041-0.319-0.061-0.48 c-0.03-0.246-0.061-0.485-0.092-0.728c-0.05-0.387-0.1-0.771-0.151-1.15c-0.049-0.36-0.097-0.718-0.148-1.07 c-0.05-0.35-0.101-0.691-0.152-1.033c-0.043-0.283-0.084-0.57-0.128-0.846c-0.1-0.637-0.202-1.261-0.307-1.864 c-0.33-1.874-0.686-3.809-1.061-5.762c-0.01-0.055-0.021-0.11-0.031-0.165c-0.377-1.954-0.772-3.925-1.188-5.881 c-0.009-0.043-0.019-0.086-0.028-0.13c-0.177-0.833-0.358-1.66-0.542-2.482c-0.069-0.31-0.139-0.616-0.209-0.924 c-0.121-0.533-0.243-1.061-0.367-1.586c-0.098-0.417-0.196-0.832-0.295-1.244c-0.021-0.084-0.04-0.171-0.061-0.255 c-0.001,0-0.001,0-0.002,0c-0.399-1.646-0.808-3.252-1.228-4.774l-6.95-3.66c0.799,3.074,1.563,6.445,2.284,9.908 c-0.865,0.452-1.605,0.995-2.281,1.627c-1.658,1.485-1.604,4.637,0.057,8.362c4.727,10.603,7.059,22.131,7.564,33.729 c0.205,4.711,0.336,9.482,0.397,14.113l6.97,0.01C269.513,186.639,268.872,174.281,267.685,164.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M234.267,107.34l-3.922,5.986l-5.337,8.159c0.366,0.191,1.181,1.471,1.65,2.415 c0.975,1.965,1.781,3.435-2.344,6.247c-0.883,0.602-0.914,1.556-0.714,2.606c0.243,1.274,0.99,2.613,5.443,1.826 c5.157-0.91,8.609-3.636,11.175-6.203c1.483-1.483,1.143-2.6-0.286-4.136C235.883,119.89,234.672,112.943,234.267,107.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M224.828,134.729l2.837,1.778l4.598-1.951c-1.12-1.008-2.358-1.856-4.05-2.087 C226.87,132.857,225.81,133.728,224.828,134.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.212,132.469c2.109,0.871,3.171,2.83,4.126,5.096c0,0,10.114-7.668,10.326-12.716 c-0.544-1.715-3.075-1.415-3.075-1.415S236.512,128.767,228.212,132.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.212,132.469c-2.109,0.871-3.205,2.746-3.205,5.014c0,0-4.497-5.282-0.836-9.269 c0.836-0.599,3.136-1.178,3.136-1.178S226.211,129.23,228.212,132.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M228.549,135.678c0,0-0.774,0-1.293,0c-0.411,0.725-0.999,10.101-1.225,15.088 c0.676,3.018,1.558,5.967,2.704,8.494c0.019,0.029,0.029,0.069,0.049,0.098c0.068,0.157,0.137,0.314,0.215,0.46 c0.137,0.304,0.284,0.598,0.441,0.882c0.215-2.136,1.039-5.438,2.146-9.131C230.234,145.789,228.549,135.678,228.549,135.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M226.321,119.48l3.275-5.814c0.067,0.145,0.145,0.312,0.223,0.479 c0.256,0.624,0.512,1.403,0.702,2.228c0.602,2.584-1.404,6.271-3.609,8.031c-0.089-0.167-0.167-0.334-0.256-0.501 c-0.412-0.847-1.114-1.96-1.515-2.317c-0.044-0.045-0.089-0.078-0.134-0.1L226.321,119.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M210.341,106.985c-0.792-3.558,4.857-8.461,4.857-8.461l-6.69-2.338 C205.491,98.375,207.45,104.569,210.341,106.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M232.885,96.743c1.576,8.873,2.943,13.971-0.34,19.665c-4.939,8.564-16.571,7.538-20.735-0.597 c-3.748-7.323-5.695-20.603,1.926-26.43C221.243,83.64,231.309,87.87,232.885,96.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M233.005,105.722l-4.196-1.15v-5.405c0,0-5.312-3.042-4.484-6.75 c0.365-2.5,1.707-6.195,1.707-6.195s8.418-0.541,10.974,0.535c-0.444,0.632-2.166,2.021-2.166,2.021S238.156,91,239.941,94 c-1.27,0.111-2.881,1.389-2.881,1.389S238.172,102.778,233.005,105.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.34,80.462c3.089,1.934,1.298,5.497,1.298,5.497l8.273,0.177 C232.471,83.521,225.302,80.327,223.34,80.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M226.566,94.236c-0.588,1.668-7.285,3.703-13.394,3.903c-4.111,0.135-8.919-1.675-8.919-1.675 s1.08-1.214,3.031-2.131c-3.694-0.917-8.368-4.158-9.65-6.789c3.337-1.185,5.858-0.999,8.317-0.586 c-3.125-2.667-3.167-6.208-3.167-6.208s15.634,6.203,21.654,3.631c6.547-2.797,11.514,2.449,7.214,6.453 C227.351,94.838,226.566,94.236,226.566,94.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M237.664,103.171c0.096,2.13-0.707,4.114-1.789,5.399c-1.629,1.933-4.14,0.391-4.722-2.021 c-0.523-2.171,0.155-5.523,2.287-6.562C235.541,98.966,237.554,100.736,237.664,103.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M219.356,104.954c0.228,0.694,0.049,1.391-0.399,1.555s-0.996-0.265-1.224-0.96 c-0.228-0.694-0.049-1.391,0.399-1.555C218.58,103.83,219.128,104.26,219.356,104.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M211.605,107.798c0.228,0.694,0.049,1.391-0.399,1.555s-0.996-0.265-1.224-0.96 c-0.228-0.694-0.049-1.391,0.399-1.555C210.829,106.674,211.377,107.104,211.605,107.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A02724"
    },
    d: "M214.255,107.431c0,0,0.053,3.903-0.72,6.142c1.39,0.505,2.923-0.691,2.923-0.691 L214.255,107.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M219.001,115.551c2.719-0.941,3.653-3.162,3.695-3.265c0.045-0.109-0.008-0.234-0.117-0.279 c-0.11-0.045-0.235,0.008-0.279,0.118c-0.011,0.025-1.071,2.556-4.209,3.237c-0.117,0.025-0.189,0.139-0.163,0.255 c0.025,0.116,0.139,0.189,0.255,0.163C218.471,115.717,218.743,115.64,219.001,115.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M221.077,100.897c0.062-0.033,0.116-0.082,0.157-0.146c0.128-0.199,0.07-0.465-0.129-0.593 c-1.973-1.267-3.779-0.432-3.854-0.395c-0.211,0.076-0.305,0.357-0.203,0.571c0.102,0.214,0.357,0.304,0.571,0.203 c0.075-0.034,1.473-0.653,3.022,0.342C220.778,100.968,220.945,100.969,221.077,100.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M210.069,103.59c0.008-0.07-0.001-0.143-0.03-0.212c-0.091-0.219-0.342-0.323-0.561-0.232 c-2.165,0.899-2.508,2.859-2.521,2.942c-0.058,0.217,0.119,0.454,0.354,0.492c0.234,0.038,0.454-0.12,0.492-0.353 c0.015-0.081,0.303-1.583,2.004-2.288C209.956,103.876,210.051,103.74,210.069,103.59z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M259.505,129.703c1.104,1.357,2.066,2.583,3.045,3.9c0.974,1.295,1.917,2.61,2.843,3.941 c1.863,2.651,3.612,5.394,5.311,8.199c1.656,2.837,3.274,5.721,4.701,8.805c1.419,3.084,2.744,6.301,3.647,9.983 c0.436,1.852,0.771,3.847,0.781,6.125c-0.017,2.248-0.374,4.225-0.885,6.092c-1.039,3.706-2.569,6.899-4.316,9.841 c-0.862,1.477-1.791,2.884-2.761,4.244c-0.961,1.364-1.968,2.678-3.019,3.946c-2.106,2.558-4.278,4.897-6.788,7.182 c-1.398,1.273-3.564,1.17-4.836-0.228c-1.038-1.141-1.161-2.791-0.413-4.051l0.089-0.148 c3.03-5.094,6.026-10.481,8.132-15.744c1.046-2.632,1.886-5.267,2.232-7.652c0.164-1.176,0.235-2.315,0.137-3.188 c-0.079-0.842-0.31-1.939-0.686-3.098c-0.758-2.34-1.897-4.89-3.245-7.395c-1.332-2.516-2.836-5.045-4.432-7.534 c-1.582-2.506-3.276-4.972-4.994-7.432l-2.624-3.659c-0.878-1.191-1.797-2.456-2.631-3.546l-0.061-0.08 c-2.303-3.011-1.728-7.318,1.282-9.621C252.965,126.324,257.172,126.841,259.505,129.703z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M164.234,203.471l85.078-3.851c1.117-0.051,2.072,0.821,2.123,1.939l-89.141,4.035 C162.244,204.476,163.117,203.522,164.234,203.471z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.234,203.471l85.078-3.851c1.117-0.051,2.072,0.821,2.123,1.939l-89.141,4.035 C162.244,204.476,163.117,203.522,164.234,203.471z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M150.689,163.995l60.529-2.74c0.74-0.033,1.528,0.532,1.758,1.264l11.62,36.876 c0.23,0.731-0.183,1.352-0.923,1.385l-60.529,2.74c-0.741,0.034-1.528-0.532-1.758-1.264l-11.62-36.876 C149.535,164.649,149.948,164.029,150.689,163.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M150.689,163.995l60.529-2.74c0.74-0.033,1.528,0.532,1.758,1.264l11.62,36.876 c0.23,0.731-0.183,1.352-0.923,1.385l-60.529,2.74c-0.741,0.034-1.528-0.532-1.758-1.264l-11.62-36.876 C149.535,164.649,149.948,164.029,150.689,163.995z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#407BFF"
    },
    d: "M212.976,162.519l11.62,36.876c0.23,0.732-0.183,1.352-0.923,1.385 l-12.455-39.525C211.958,161.221,212.746,161.787,212.976,162.519z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#407BFF"
    },
    d: "M226.939,200.633l22.373-1.013c1.117-0.051,2.072,0.821,2.123,1.939L225,202.755 C224.949,201.638,225.822,200.683,226.939,200.633z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8B7B"
    },
    d: "M255.202,197.277l-5.722,0.838l5.86,8.144c0,0,9.306-1.492,8.23-5.617l-1.958-1.658 C259.932,197.561,257.565,196.931,255.202,197.277z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8B7B"
    },
    points: "242.481,200.548 249.653,206.804 255.34,206.258 249.48,198.114  "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.84c6e265ba0c752c9deaffbeb2854796.svg";
export { ForwardRef as ReactComponent };